import script from "./base-svg.vue?vue&type=script&lang=ts&setup=true"
export * from "./base-svg.vue?vue&type=script&lang=ts&setup=true"

import "./base-svg.vue?vue&type=style&index=0&id=09a66fca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a66fca"]])

export default __exports__